"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunnelDataProvider = exports.useFunnelDataContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const lodash_1 = __importDefault(require("lodash"));
const use_custom_compare_1 = require("use-custom-compare");
const ProjectsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectsProvider");
const DataProviderCommonTypes_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/DataProviderCommonTypes");
const FunnelApiService_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/funnel/FunnelApiService");
const FunnelDataContext = React.createContext(undefined);
const useFunnelDataContext = () => {
    const context = React.useContext(FunnelDataContext);
    if (!context) {
        throw new Error("useFunnelDataContext must be used within a FunnelDataContext.Provider");
    }
    return context;
};
exports.useFunnelDataContext = useFunnelDataContext;
const FunnelDataProvider = (props) => {
    const { projectApiKey } = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const projectsContext = (0, ProjectsProvider_1.useProjectsContext)();
    const fetchFunnel = (0, react_1.useCallback)(async (parameters) => {
        try {
            if (process.env.NODE_ENV === "development") {
                console.log("FunnelDataProvider.fetchFunnel: start with", { parameters, projectApiKey });
            }
            const actorResult = await projectsContext.getActor(projectApiKey);
            if (!lodash_1.default.isNil(actorResult.error)) {
                console.warn("fetchFunnel failed. no actor", actorResult.error);
                // noinspection ExceptionCaughtLocallyJS
                throw actorResult.error;
            }
            else {
                const projectFunnelResultByChunks = (0, FunnelApiService_1.getProjectFunnelResultByChunks)(actorResult.actors, actorResult.accessToken, parameters.lastNDays, parameters.returnEvents);
                if (!!process.env.IS_TEST_SERVER) {
                    console.log("FunnelDataProvider.fetchFunnel: projectFunnelResultByChunks", projectFunnelResultByChunks);
                }
                const result = await (0, DataProviderCommonTypes_1.getFeatureStateFromICPromise)(projectFunnelResultByChunks);
                if (!!process.env.IS_TEST_SERVER) {
                    console.log("FunnelDataProvider.fetchFunnel: result", result);
                }
                /*if (process.env.NODE_ENV === "development") {
                    if (result.state) {
                //         // console.log("result.state before", _.cloneDeep(result.state));
                        let responseOvertime = result.state.overtime;
                        const responseClassic = result.state.classic;
                        const filledEventNamesSet = _.map<EventQuery, string>(parameters.returnEvents, v => v.eventDescription.name)
                        if (_.isEmpty(responseOvertime)) {
                            for (let i = 0; i < filledEventNamesSet.length; i++) {
                                responseOvertime.push(HighchartsRandomChartGenerator.random2(parameters.lastNDays))
                            }
                //             // console.log("response.overtime 1", responseOvertime);
                        } else {
                            //временно убираем лишний первый массив, так как сервер в нем всегда присылает сессии
                            responseOvertime = _.takeRight(responseOvertime, responseOvertime.length - 1)
                //             // console.log("response.overtime 2", _.cloneDeep(responseOvertime));
                        }
                        result.state.overtime = responseOvertime

                        if (_.isEmpty(responseClassic)) {
                            result.state.classic = _.take(_.map(responseOvertime, (v, idx) => {
                                return v[0] === 0 ? responseOvertime.length - idx : v[0];
                            }), responseOvertime.length)
                        }
                    }
                }*/
                // console.log("final result.state", _.cloneDeep(result.state));
                return result;
                // return await getFeatureStateFromICResult<{ ok: FunnelChartResultData }, FunnelChartResultData>({"ok": {data: [13209, 11277]}});
            }
        }
        catch (e) {
            throw e;
        }
        // noinspection ExceptionCaughtLocallyJS
        throw new Error("unknown");
    }, [projectApiKey]);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        fetchFunnel,
    }), [
        fetchFunnel,
    ], lodash_1.default.isEqual);
    return React.createElement(FunnelDataContext.Provider, { value: value }, props.children);
};
exports.FunnelDataProvider = FunnelDataProvider;
